/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface PhoneLoginResponse
 */
export interface PhoneLoginResponse {
    /**
     * 
     */
    user: User;
}

/**
 * Check if a given object implements the PhoneLoginResponse interface.
 */
export function instanceOfPhoneLoginResponse(value: object): value is PhoneLoginResponse {
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function PhoneLoginResponseFromJSON(json: any): PhoneLoginResponse {
    return PhoneLoginResponseFromJSONTyped(json, false);
}

export function PhoneLoginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneLoginResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'user': UserFromJSON(json['user']),
    };
}

export function PhoneLoginResponseToJSON(json: any): PhoneLoginResponse {
    return PhoneLoginResponseToJSONTyped(json, false);
}

export function PhoneLoginResponseToJSONTyped(value?: PhoneLoginResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': UserToJSON(value['user']),
    };
}

